module.exports = "https://static.wanderu.com/ui-react/_next/static/media/economist.304926db.png";